module.exports = __webpack_public_path__ + "img/PC.8fd945fb.png";